export default {
  pending: 'منتظر تایید',
  accepted: 'تایید شده',
  serviceStarted: 'جاری',
  finished: 'پایان',
  tariffBased: 'تعرفه ای',
  cancelReason: 'دلیل لغو',
  cancelDescription: 'توضیحات لغو',
  generalLoadInformation: 'اطلاعات کلی سفارش',
  package: 'بسته بندی',
  typeOfShippingDocument: 'نوع سند حمل',
  monetaryValue: 'ارزش بار',
  furnitureDate: 'تاریخ اسباب‌کشی',
  furnitureHour: 'ساعت اسباب‌کشی',
  loadDate: 'تاریخ بارگیری',
  loadHour: 'ساعت بارگیری',
  dischargeDate: 'تاریخ تخلیه',
  dischargeTime: 'زمان تخلیه',
  areYouSureToCancel_courierForThisLoad:
    "آیا از لغو ' {courier} ' برای این سفارش اطمینان دارید؟",
  areYouSureToAccept_courierForThisLoad:
    "آیا از تایید ' {courier} ' برای این سفارش اطمینان دارید؟",
  areYouSureToAcceptable_courierForThisLoad:
    "آیا از قبول پیشنهاد ' {courier} ' برای این سفارش اطمینان دارید؟",

  areYouSureToAcceptForThisLoad:
    'آیا از تایید راننده برای این سفارش اطمینان دارید؟',
  insuranceCost: 'هزینه بیمه',
  isTotalAmountOf_rialsApproved:
    'آیا مبغ کل {totalAmount} ریال ({totalAmountToman}) مورد تایید است؟',
  doYouWantAccept_companyForThisLoad:
    "آیا مایل به تایید پروژه ' {company} ' برای این سفارش هستید؟",
  totalExcessAmountOf_rialsApproved:
    'آیا مجموع هزینه مازاد {totalExcess} ریال ({total}) مورد تایید است؟',
  totalCostOf_rialsApproved:
    'آیا هزینه کل {totalCost} ریال ({totalCostToman}) مورد تایید است؟',
  areYouSureOfStartingThisLoadWithoutAssigningDriver:
    'آیا از شروع این سفارش بدون تخصیص راننده اطمینان دارید؟',
  areYouSureYouWantToFinishThisLoad:
    'از پایان دادن به این سفارش اطمینان دارید؟',
  areYouSureYouWantToRevert_nameAcceptance:
    'آیا از ابطال تاییدیه {name} اطمینان دارید؟',
  areYouSureYouWantToRevertAssignedDriversOfThisLoad:
    'آیا از ابطال رانندگان اختصاص یافته به این سفارش اطمینان دارید؟',
  revertLoadSteps: 'ابطال مراحل حمل سفارش',
  startWithoutAssignDriver: 'شروع بدون تخصیص راننده',
  startOrderForBranch: 'شروع بار برای شعبه',
  revertStartWithoutAssignDriver: 'ابطال شروع بدون تخصیص راننده',
  areYouSureYouWantToRevertLoadSteps:
    'آیا از ابطال مراحل حمل این سفارش اطمینان دارید؟',
  areYouSureYouWantToRevertStartWithoutAssignDriver:
    'آیا از ابطال شروع بدون تخصیص راننده برای این سفارش اطمینان دارید؟',
  areYouSureYouWantToAssignThisDriverForThisOrder:
    'آیا از تخصیص راننده برای این سفارش اطمینان دارید؟',
  areYouSureYouWantToRevertFinish:
    'آیا از ابطال پایان این سفارش اطمینان دارید؟',
  assignDriver: 'تخصیص راننده',
  reassignDriver: 'تخصیص مجدد راننده',
  areYouSureYouWantToDeleteThisDraft: 'آیا از حذف این پیش نویس اطمینان دارید؟',
  draftDeletedSuccessfully: 'پیش نویس با موفقیت حذف شد',
  pricing: 'تعیین قیمت',
  editPricing: 'ویرایش قیمت',
  acceptOfCourier_: "تایید پروژه ' {courier} '",
  areYouSureYouWantToAddOffersOf_companies:
    "از افزودن پیشنهاد پروژه (های) ' {companies} ' اطمینان دارید؟",
  areYouSureYouWantToAddOffer: 'از افزودن پیشنهاد اطمینان دارید؟',
  addingOffers: 'افزودن پیشنهاد(ها)',
  assignDriver: 'تخصیص راننده',
  activeTariff: 'تعرفه فعال',
  assignDrivers: 'تخصیص راننده(ها)',
  reassignDrivers: 'تخصیص مجدد راننده(ها)',
  markDriverCoordinatesOnMap: 'موقعیت مکانی راننده را روی نقشه مشخص کنید',
  startMoving: 'شروع حرکت',
  reachingTheOrigin: 'رسیدن به مبدا',
  endOfDownload: 'بارگیری در مبدا',
  reachingTheDestination1: 'رسیدن به مقصد اول',
  reachingTheDestination2: 'رسیدن به مقصد دوم',
  reachingTheDestination3: 'رسیدن به مقصد سوم',
  reachingTheDestination4: 'رسیدن به مقصد چهارم',
  reachingTheDestination: 'رسیدن به مقصد نهایی',
  emptyingTheConsignment: 'اتمام سفارش',
  backTo_: 'بازگشت به {step}',
  destinationToRevert: 'مقصد برای بازگشت',
  updatingPrice: 'بروز رسانی قیمت',
  loadHasBeenFinishedSuccessfully: 'سفارش با موفقیت پایان یافت',
  cancelLoad: 'لغو سفارش',
  loadAsDraft: 'سفارش به عنوان پیش نویس',
  ongoing: 'در حال پیگیری',
  areYouSureYouWantToChangeThisLoadStateToOngoing:
    "از تغییر وضعیت این سفارش به 'در حال پیگیری' اطمینان دارید؟",
  loadStateSuccessfullyChangedToOngoing:
    "وضعیت سفارش با موفقیت به 'در حال پیگیری' تغییر یافت",
  shipmentDrafts: 'پیش نویس سفارش‌ها',
  postalPostageDetail: 'مشخصات مرسوله پستی',
  defaultVehicle: 'خودروی پیشفرض',
  collectionTime: 'زمان جمع آوری',
  stopInPlace: 'توقف در محل',
  returnToOrigin: 'بازگشت به مبدا',
  trackingCodeOf_: 'کد رهگیری {title}',
  orderTracking: 'پیگیری سفارش',
  originAndDestinationInfo: 'اطلاعات مبدا و مقصد',
  estimatedTimeFromOriginToDestination: 'زمان تقریبی مبدا تا مقصد',
  distanceFromOriginToDestination: 'فاصله مبدا تا مقصد',
  deliverer: 'تحویل دهنده',
  transferee: 'تحویل گیرنده',
  plate: 'پلاک',
  floor: 'طبقه',
  unit: 'واحد',
  distanceFromDoorToCar: 'فاصله درب تا خودرو',
  destination1: 'تحویل به مقصد اول',
  destination2: 'تحویل به مقصد دوم',
  destination3: 'تحویل به مقصد سوم',
  destination4: 'تحویل به مقصد چهارم',
  destination5: 'تحویل به مقصد پنجم',
  destination6: 'تحویل به مقصد ششم',
  destination7: 'تحویل به مقصد هفتم',
  destination8: 'تحویل به مقصد هشتم',
  destination9: 'تحویل به مقصد نهم',
  destination10: 'تحویل به مقصد دهم',
  destination11: 'تحویل به مقصد یازدهم',
  destination12: 'تحویل به مقصد دوازدهم',
  destination13: 'تحویل به مقصد سیزدهم',
  destination14: 'تحویل به مقصد چهاردهم',
  destination15: 'تحویل به مقصد پانزدهم',
  destination16: 'تحویل به مقصد شانزدهم',
  destination17: 'تحویل به مقصد هفدهم',
  destination18: 'تحویل به مقصد هجدهم',
  destination19: 'تحویل به مقصد نوزدهم',
  destination20: 'تحویل به مقصد بیستم',
  destination21: 'تحویل به مقصد بیست و یکم',
  destination22: 'تحویل به مقصد بیست و دوم',
  destination23: 'تحویل به مقصد بیست و سوم',
  destination24: 'تحویل به مقصد بیست و چهارم',
  destination25: 'تحویل به مقصد بیست و پنجم',
  destination26: 'تحویل به مقصد بیست و ششم',
  destination27: 'تحویل به مقصد بیست و هفتم',
  destination28: 'تحویل به مقصد بیست و هشتم',
  destination29: 'تحویل به مقصد بیست و نهم',
  destination30: 'تحویل به مقصد سی‌ام',
  destination31: 'تحویل به مقصد سی و یکم',
  destination32: 'تحویل به مقصد سی و دوم',
  destination33: 'تحویل به مقصد سی و سوم',
  destination34: 'تحویل به مقصد سی و چهارم',
  destination35: 'تحویل به مقصد سی و پنجم',
  destination36: 'تحویل به مقصد سی و ششم',
  destination37: 'تحویل به مقصد سی و هفتم',
  destination38: 'تحویل به مقصد سی و هشتم',
  destination39: 'تحویل به مقصد سی و نهم',
  destination40: 'تحویل به مقصد چهلم',
  destination41: 'تحویل به مقصد چهل و یکم',
  destination42: 'تحویل به مقصد چهل و دوم',
  destination43: 'تحویل به مقصد چهل و سوم',
  destination44: 'تحویل به مقصد چهل و چهارم',
  destination45: 'تحویل به مقصد چهل و پنجم',
  destination46: 'تحویل به مقصد چهل و ششم',
  destination47: 'تحویل به مقصد چهل و هفتم',
  destination48: 'تحویل به مقصد چهل و هشتم',
  destination49: 'تحویل به مقصد چهل و نهم',
  destination50: 'تحویل به مقصد پنجاهم',
  destination51: 'تحویل به مقصد پنجاه و یکم',
  destination52: 'تحویل به مقصد پنجاه و دوم',
  destination53: 'تحویل به مقصد پنجاه و سوم',
  destination54: 'تحویل به مقصد پنجاه و چهارم',
  destination55: 'تحویل به مقصد پنجاه و پنجم',
  destination56: 'تحویل به مقصد پنجاه و ششم',
  destination57: 'تحویل به مقصد پنجاه و هفتم',
  destination58: 'تحویل به مقصد پنجاه و هشتم',
  destination59: 'تحویل به مقصد پنجاه و نهم',
  destination60: 'تحویل به مقصد شصتم',
  destination61: 'تحویل به مقصد شصت و یکم',
  destination62: 'تحویل به مقصد شصت و دوم',
  destination63: 'تحویل به مقصد شصت و سوم',
  destination64: 'تحویل به مقصد شصت و چهارم',
  destination65: 'تحویل به مقصد شصت و پنجم',
  destination66: 'تحویل به مقصد شصت و ششم',
  destination67: 'تحویل به مقصد شصت و هفتم',
  destination68: 'تحویل به مقصد شصت و هشتم',
  destination69: 'تحویل به مقصد شصت و نهم',
  destination70: 'تحویل به مقصد هفتادم',
  destination71: 'تحویل به مقصد هفتاد و یکم',
  destination72: 'تحویل به مقصد هفتاد و دوم',
  destination73: 'تحویل به مقصد هفتاد و سوم',
  destination74: 'تحویل به مقصد هفتاد و چهارم',
  destination75: 'تحویل به مقصد هفتاد و پنجم',
  destination76: 'تحویل به مقصد هفتاد و ششم',
  destination77: 'تحویل به مقصد هفتاد و هفتم',
  destination78: 'تحویل به مقصد هفتاد و هشتم',
  destination79: 'تحویل به مقصد هفتاد و نهم',
  destination80: 'تحویل به مقصد هشتادم',
  destination81: 'تحویل به مقصد هشتاد و یکم',
  destination82: 'تحویل به مقصد هشتاد و دوم',
  destination83: 'تحویل به مقصد هشتاد و سوم',
  destination84: 'تحویل به مقصد هشتاد و چهارم',
  destination85: 'تحویل به مقصد هشتاد و پنجم',
  destination86: 'تحویل به مقصد هشتاد و ششم',
  destination87: 'تحویل به مقصد هشتاد و هفتم',
  destination88: 'تحویل به مقصد هشتاد و هشتم',
  destination89: 'تحویل به مقصد هشتاد و نهم',
  destination90: 'تحویل به مقصد نودم',
  destination91: 'تحویل به مقصد نود و یکم',
  destination92: 'تحویل به مقصد نود و دوم',
  destination93: 'تحویل به مقصد نود و سوم',
  destination94: 'تحویل به مقصد نود و چهارم',
  destination95: 'تحویل به مقصد نود و پنجم',
  destination96: 'تحویل به مقصد نود و ششم',
  destination97: 'تحویل به مقصد نود و هفتم',
  destination98: 'تحویل به مقصد نود و هشتم',
  destination99: 'تحویل به مقصد نود و نهم',
  destination100: 'تحویل به مقصد صدم',
  finalDestination: 'تحویل به مقصد نهایی',
  originWeightOfWeighbridge: 'وزن باسکول در مبدا',
  destinationWeightOfWeighbridge: 'وزن باسکول در مقصد',
  receiptOfWeighbridge: 'رسید باسکول',
  laborerCount: 'تعداد کارگر',
  carLoad: 'بارگیر',
  driverMobile: 'موبایل راننده',
  courierShare: 'سهم پروژه',
  driverShare: 'سهم راننده',
  carPriceDetails: 'جزئیات قیمت خودرو',
  laborerPriceDetails: 'جزئیات قیمت کارگر',
  technicalForce: 'نیروی فنی',
  costlyItems: 'اقلام هزینه دار',
  otherItems: 'سایر آیتم ها',
  diverSuggestedAmount: 'قیمت پیشنهادی راننده',
  driverName: 'نام راننده',
  driverNationalId: 'شماره ملی راننده',
  vehicleSmartCardNumber: 'کد هوشمند ناوگان',
  courierOffer: 'پیشنهاد پروژه ها',
  priced: 'قیمت دهی شده',
  waitingForPricing: 'منتظر قیمت دهی',
  excessCost: 'هزینه مازاد',
  submitExcessCost: 'ثبت هزینه مازاد',
  editExcessCost: 'ویرایش هزینه مازاد',
  acceptCourier: 'تایید پروژه',
  submitExcessCostFor_: "ثبت هزینه مازاد برای '{courier}'",
  editExcessCostOf_: "ویرایش هزینه مازاد '{courier}'",
  courierCostDetail_: "جزئیات هزینه '{courier}'",
  totalExcessCost: 'مجموع هزینه مازاد',
  pricing: 'تعیین قیمت',
  pricingCourierOffer_: "تعیین قیمت پیشنهاد '{courier}'",
  editPrice: 'ویرایش قیمت',
  editPriceOfCourierOffer_: "ویرایش قیمت پیشنهاد '{courier}'",
  amountUnderCommissionError:
    'مبلغ وارد شده کمتر از مقدار کمیسیون ({commissionAmount}) می باشد',
  totalAmountUnderCommissionError:
    'جمع مبالغ وارد شده کمتر از مقدار کمیسیون ({commissionAmount}) می باشد',
  addOffer: 'افزودن پیشنهاد',
  noNewOffers: 'پیشنهاد جدیدی موجود نیست',
  noNewPackages: 'بسته بندی جدیدی موجود نیست',
  distance: 'فاصله',
  carPayableAmount: 'قابل پرداخت خودرو',
  laborerPayableAmount: 'قابل پرداخت کارگر',
  carCostDetail: 'جزئیات هزینه خودرو',
  technicalForceCostDetail: 'جزئیات هزینه نیروی فنی',
  costlyItemsCostDetail: 'جزئیات هزینه اقلام هزینه دار',
  otherItemsCostDetail: 'جزئیات هزینه سایر آیتم ها',
  postalPostageSpecifications: 'مشخصات مرسوله پستی',
  monetaryValue: 'ارزش',
  customerMobile: 'موبایل مشتری',
  cancelOrder: 'لغو سفارش',
  continueOrderRegistration: 'ادامه ثبت سفارش',
  areYouSureYouWantToDeleteThisTemplate:
    'آیا از حذف این الگوی سفارش اطمینان دارید؟',
  templateDeletedSuccessfully: 'الگوی سفارش با موفقیت حذف شد',
  loadDetail: 'جزئیات سفارش',
  notStarted: 'شروع نشده',
  loadSteps: 'مراحل حمل سفارش',
  stepsToAdvanceTheLoad: 'مراحل پیش بردن سفارش',
  pleaseSelectVehicle: 'لطفا خودرو رو انتخاب کنید',
  resetCoordinates: 'بازنشانی مختصات',
  stepsHistory: 'تاریخچه مراحل',
  noStepDoneYet: 'هنوز مرحله ای تکمیل نشده',
  noResponseHasBeenRecordedForThisFeedbackYet:
    'هنوز پاسخی برای این بازخورد ثبت نشده است',
  recordResponse: 'ثبت پاسخ',
  noFeedbackHasBeenRecordedForThisShipmentYet:
    'هنوز بازخوردی برای این سفارش ثبت نشده است',
  recordFeedback: 'ثبت بازخورد',
  dischargeDayPart: 'زمان تخلیه',
  orderTime: 'ساعت سفارش',
  orderDate: 'تاریخ سفارش',
  waitMinute: 'مدت زمان توقف',
  roundTrip: 'بازگشت به مبدا',
  updateShipmentMainInfo: 'ویرایش  اطلاعات کلی سفارش',
  loadType: 'نوع بار',
  packageType: 'نوع بسته بندی',
  weight: 'وزن',
  loadWeight: 'وزن بار',
  kilogram: 'کیلوگرم',
  templateId: 'شناسه الگو',
  draftId: 'شناسه پیش نویس',
  otherCost: 'سایر هزینه ها',
  totalCost: 'جمع کل',
  tax: 'مالیات',
  toll: 'عوارض',
  badpaShare: 'سهم بادپا',
  MainCourierShare: 'سهم بابری اصلی',
  pricingType: 'نحوه قیمت دهی',
  loadRange: 'محدوده بار',
  registerOrderTime: 'زمان ثبت سفارش',
  deliveryCode: 'کد تحویل',
  deliveryResult: 'نتیجه تحویل',
  deliverySuccessful: 'تحویل موفق',
  deliveryFailed: 'تحویل ناموفق',
  pleaseSelectDeliveryResult: 'لطفا نتیجه تحویل را انتخاب کنید',
  dischargeShipmentCode: 'کد تخلیه سفارش',
  sendDeliveryCodeToCustomer: 'ارسال کد به مشتری',
  deliveryCodeSentSuccessfully: 'کد با موفقیت ارسال شد',
  cancelType: 'نوع لغو',
  cancelLoadReason: 'دلیل لغو سفارش',
  cancelLoadDescription: 'توضیحات لغو سفارش',
  updatePrice: 'بروزرسانی قیمت',
  auctionCommissionWarning:
    'مبلغ وارد شده کمتر از مقدار کمیسیون ({commissionAmount} ریال) می باشد',
  recordOriginWeighbridge: 'ثبت باسکول مبدا',
  recordDestinationWeighbridge: 'ثبت باسکول مقصد',
  finishLoad: 'پایان',
  loadForwardSteps: 'مراحل جلو بردن سفارش',
  loadRevertSteps: 'مراحل ابطال سفارش',
  revertAcceptance: 'ابطال تاییدیه',
  revertDriverAssignment: 'ابطال تخصیص راننده',
  destination: 'مقصد',
  coordinates: 'مختصات',
  cancelReason: 'دلیل لغو سفارش',
  originAndDestinationShouldDiffrent: 'مبدا و مقصد نباید یکسان باشند!',
  addPackage: 'افزودن پکیج',
  atLeastOnePackageIsRequired: 'حداقل یک بسته بندی مورد نیاز است',
  reserveOrderForLater: 'رزرو درخواست برای آینده',
  revertOffer: 'ابطال قبول پیشنهاد',
  atLeastOneEmployeeNeeded: 'برای ادامه انتخاب حداقل یک نیروی فنی الزامی است',
  driversOffers: 'پیشنهادات رانندگان',
  IWantInsurance: 'بیمه می‌خواهم',
  forAddCarToThisBarYouShouldRemoveAllCarExcludedCarsAreYouSure:
    'برای افزودن خودرو به این بار می بایست تمام افراد با فیلد بدون خودرو حذف شوند آیا مطمينید؟',
  carCanNotBeEmpty: 'لیست خودرو نمی تواند خالی باشد ',
  thisEmployeeCantAddedCuzThisLoadHasCar:
    'این کارگر نمیتواند در این بار اضافه شود ابتدا لیست خودرو را خالی کنید',
  employeeShouldExist: 'حداقل یک کارگر می بایست وجود داشته باشد',
  forAddExcludedCarToThisLoadYouShouldRemoveAllCarsAreYouSure:
    'برای انجام این عملیات میبایست تمام خودرو ها را حذف کنید آیا مطمينید؟',
  offer: 'پیشنهاد',
  chooseAtLeastOneTypeOfLoad: 'حداقل یک نوع بار انتخاب نمایید',
  driverInformation: 'اطلاعات راننده',
  loadingStartTime: 'اغاز زمان بارگیری',
  loadingEndTime: 'پایان زمان بارگیری',
  dischargeStartTime: 'زمان اغاز تخلیه',
  dischargeEndTime: 'زمان پایان تخلیه',
  changeDriver: 'تغییر راننده',
  driverEditedSuccessfully: 'راننده با موفقیت ویرایش شد',
  archiveDriver: 'بایگانی راننده',
  deliveryState: 'وضعیت تحویل',
  orderCount: 'تعداد سفارش',
  loading: 'بارگیری',
  referToAdmin: 'ارجاع به ادمین',
  referToCourier: 'ارجاع به پروژه',
  orderReferToCourierSuccessfully: 'سفارش با موفقیت به پروژه ارجاع داده شد',
  orderReferToAdminSuccessfully: 'سفارش با موفقیت به ادمین ارجاع داده شد',
  referTo: 'ارجاع به',
  typesShouldBeSame: 'نوع بار می بایست یکسان باشد',
  id: 'کد سفارش',
  courier: 'نام پروژه',
  type: 'نوع درخواست',
  creationTime: 'تاریخ ثبت سفارش',
  state: 'وضعیت جاری',
  senderNationalId: 'کد ملی فرستنده',
  senderMobile: 'موبایل فرستنده',
  originProvince: 'استان مبدا',
  originCity: 'شهر مبدا',
  originAddress: 'آدرس مبدا',
  originZipCode: 'کد پستی مبدا',
  receiverNationalId: 'کد ملی گیرنده',
  receiverMobile: 'موبایل گیرنده',
  destinationProvince: 'استان مقصد',
  destinationCity: 'شهر مقصد',
  destinationAddress: 'آدرس مقصد',
  destinationZipCode: 'کد پستی مقصد',
  carType: 'نوع وسیله نقلیه',
  vehiclePlateNumber: 'شماره پلاک انتظامی',
  driverFullName: 'نام و نام خانوادگی راننده',
  driverNationalId: 'کد ملی راننده',
  driverMobile: 'موبایل راننده',
  smartFleetNumber: 'شماره ناوگان هوشمند',
  productName: 'نام مرسوله',
  productQuantity: 'تعداد مرسوله',
  productWeight: 'تناژ وزنی',
  productVolume: 'تناژ حجمی',
  productPrice: 'ارزش مالی',
  additionalServiceInsurance: 'بیمه خدمات اضافی',
  additionalServicePackageTypeTitle: 'نوع بسته‌بندی',
  additionalServiceTypeTitle: 'نوع خدمات اضافی',
  additionalServiceFactor: 'ضریب خدمات اضافی',
  additionalServiceCOD: 'پرداخت در محل',
  additionalServiceCapillaryDistribution: 'توزیع مویرگی',
  additionalServiceWorker: 'کارگر',
  additionalServiceDischargeLoad: 'بارگیری تخلیه بار',
  additionalService: 'خدمات اضافی',
  factorId: 'شناسه فاکتور',
  totalCost: 'هزینه کل',
  addedValue: 'ارزش افزوده',
  insurance: 'بیمه',
  driverCost: 'هزینه راننده',
  trackingCode: 'کد پیگیری',
  paymentType: 'نوع پرداخت',
  senderFullName: 'نام و نام خانوادگی فرستنده',
  receiverFullName: 'نام و نام خانوادگی گیرنده',
  excelReport: 'گزارش اکسل {title}',
  general: 'مشخصات سفارش',
  sender: 'مشخصات مبدا',
  receiver: 'مشخصات مقصد',
  driver: 'مشخصات راننده',
  product: 'مشخصات مرسوله',
  additionalService: 'درخواست خدمات جانبی',
  pricing: 'قیمت دهی',
  vehicleCarLoad: 'ویژگی وسیله نقلیه',
  orderDetail: 'اطلاعات سفارش',
  orderId: 'شناسه سفارش',
  serviceType: 'نوع سرویس',
  receiptRequired: 'اخذ رسید',
  codService: 'خدمات COD',
  capillaryDistribution: 'توزیع مویرگی',
  laborService: 'کارگری',
  otherServices: 'سایر خدمات',
  failedReason: 'دلیل عدم تحویل',
  invoiceNumber: 'شماره فاکتور',
  valueAdded: 'ارزش افزوده',
  insuranceAmount: 'مبلغ بیمه',
  additionalServices: 'خدمات جانبی',
  driverFee: 'حق الزحمه راننده'
}
